/*
 * @Date: 2020-03-12 18:12:28
 * @LastEditors: yuanjianlong@aixuexi.com
 * @LastEditTime: 2020-03-18 16:48:49
 * @FilePath: \st-teacher-2020\src\service\index.ts
 */
import commonApis from './common';
import beikeApis from './beike';
import feedbackApis from './feeback';

export default {
  common: { ...commonApis },
  bk: { ...beikeApis },
  feedback: { ...feedbackApis },
};
